import { galleryAPI } from "../services/api";
import { getStaticImageUrl } from "../config/gcs";

// Gallery data service - fetches from backend API
export const getGallery = async () => {
  const response = await galleryAPI.getAll();
  return response.data || [];
};

// Get gallery by category
export const getGalleryByCategory = async (category) => {
  const response = await galleryAPI.getAll();
  const allGallery = response.data || [];
  return allGallery.filter((item) => item.category === category);
};

// Get featured gallery items
export const getFeaturedGallery = async (limit = 12) => {
  const response = await galleryAPI.getFeatured(limit);
  return response.data || [];
};

// Get featured gallery by category
export const getFeaturedGalleryByCategory = async (category, limit = 12) => {
  const response = await galleryAPI.getFeaturedByCategory(category, limit);
  return response.data || [];
};

// Gallery header data (static)
export const galleryHeader = {
  head: "Gallery Glimpses",
  desc: "Explore ELF Shipping's Gallery Glimpses for a snapshot of our precision, expertise, and commitment. From high-profile events to seamless cargo handling, each image tells a story of logistics excellence across air, ocean, GCC trucking, and more. Witness the impact of our services in every frame.",
  img: getStaticImageUrl("Gallery/team.png"),
  title: "Featured Images",
};
